import { create } from 'jss'
import camelCase from 'jss-plugin-camel-case'

const stylesSheet = create()
  .use(camelCase())
  .createStyleSheet({
    '@keyframes error-shake': {
      '0%': {
        transform: 'translateX(0)',
        animationTimingFunction: 'ease-out',
      },
      '12%': {
        transform: 'translateX(-15px)',
        animationTimingFunction: 'ease-in-out',
      },
      '26%': {
        transform: 'translateX(12px)',
        animationTimingFunction: 'ease-in-out',
      },
      '42%': {
        transform: 'translateX(-10px)',
        animationTimingFunction: 'ease-in-out',
      },
      '62%': {
        transform: 'translateX(8px)',
        animationTimingFunction: 'ease-in-out',
      },
      '82%': {
        transform: 'translateX(-5px)',
        animationTimingFunction: 'ease-in-out',
      },
      '100%': {
        transform: 'translateX(0)',
        animationTimingFunction: 'ease-in',
      },
    },
    markError: {
      animation: '0.7s $error-shake',
    },
  })
  .attach()

interface Props {
  container?: HTMLElement
}

// TODO: reimplement this solution without direct access to elements - the way it's working right now looks very hacky
const _scrollToError = (props?: Props) => {
  const ancestor = (props && props.container) || document

  const el =
    ancestor.querySelector('input:invalid') ||
    ancestor.querySelector('textarea:invalid') ||
    ancestor.querySelector('.error')

  if (!el) {
    return
  }
  el.scrollIntoView()

  const shaker = el.classList.contains('error') ? el : el.parentElement

  // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
  shaker.classList.remove(stylesSheet.classes.markError)
  setTimeout(() => {
    // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
    shaker.classList.add(stylesSheet.classes.markError)
  }, 300)
}

export const scrollToError = (props?: Props) => {
  // in case it's used in @action, we need some small timeout
  setTimeout(() => {
    _scrollToError(props)
  }, 10)
}
